<template>
    <div class="tree">
        <ul class="tree-list" id="sub-menu">
            <li v-for="(tree, index) in treeData" :key="index">
                <node-tree :node="tree" :children="children" :label="label" :value="value" @selectNode="selectNode" :marginLeft="marginLeft"></node-tree>
            </li>
        </ul>
    </div>
</template>

<script>
import NodeTree from "./NodeTree";
/* 
* Import libs and componnents
*/
export default {
    /* 
    * Name of component
    */
    name: "Tree",
    props: {
        treeData: [Array,Object],
        children: String,
        label : String,
        value : String,
        marginLeft: String
    },
    /* 
    * Declare components
    */
    components: {
        NodeTree
    },
    methods: {
        selectNode: function(categoryCd) {
            this.$emit('selectNode', categoryCd);
        }
    }
}
</script>